<h4>{{ currentAccount }}</h4>
<div>
  <p-table
    *ngIf="qboTrackedItems && qboTrackedItems.length > 0"
    [value]="qboTrackedItems"
    [(selection)]="batchSelectedItems"
    dataKey="uuid"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 1px">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th class="text-center">STATUS</th>
        <th>
          {{
            type == "expense" || type == "receipt_requests"
              ? "PAYEE / ACCOUNT"
              : "RECEIVED FROM"
          }}
        </th>
        <th>DATE</th>
        <th style="text-align: right">AMOUNT</th>
        <th>COMMENTS</th>
        <th
          *ngIf="type != 'expense'"
          [ngStyle]="{ width: type == 'expense' ? '19%' : '38%' }"
        >
          {{
            type == "expense"
              ? "ACCOUNT"
              : type == "deposit"
                ? "EXPLAIN DEPOSIT"
                : "FILE UPLOAD"
          }}
        </th>
        <th *ngIf="type == 'expense' && hasSelectableSalesTax">SALES TAX</th>
        <th style="width: 19%" *ngIf="type == 'expense'">RECEIPT</th>

        <th *ngIf="type == 'expense'">CLASS / ACTIONS</th>

        @if (type == "receipt_requests") {
          <th>ACTIONS</th>
        }

        <!-- <th style="width: 18%">ACTIONS</th> -->
      </tr>
    </ng-template>

    <!-- Add a class of "striped" for the odd iterations of this loop -->
    <ng-template pTemplate="body" let-tracked_item let-i="rowIndex">
      <tr
        style="height: 56px"
        [ngClass]="{
          selected: tracked_item.selected,
          'no-margin-bottom': type == 'expense',
          striped: i % 2 == 0,
        }"
      >
        <td class="no-border">
          <p-tableCheckbox
            [ngClass]="{ 'fix-checkbox': type == 'expense' }"
            (click)="$event.stopPropagation()"
            [value]="tracked_item"
          ></p-tableCheckbox>
        </td>

        <!-- STATUS column -->
        <td
          class="no-border text-center"
          (click)="selectTrackedItem(tracked_item)"
          style="cursor: pointer"
        >
          <div
            class="status-badge"
            [ngClass]="{
              open: tracked_item.answer_status == 'open',
              answered: tracked_item.answer_status == 'answered',
              closed: tracked_item.answer_status == 'closed',
            }"
          >
            {{ tracked_item.answer_status }}
          </div>
          <i
            class="tio-info_outined"
            tooltip="Error in QuickBooks update"
            style="color: #bd1105; cursor: pointer"
            (click)="goToQuickBooks(tracked_item)"
            *ngIf="tracked_item?.integration_data?.has_qbo_error"
          ></i>
        </td>

        <!-- PAYEE / ACCOUNT column -->
        <td class="no-border qbo-cap-dropdown">
          <ng-container
            *ngIf="
              type == 'expense' || type == 'receipt_requests';
              else receivedFromTemplate
            "
          >
            <input
              *ngIf="type == 'expense'"
              [(ngModel)]="tracked_item.selectedVendorName"
              [typeahead]="vendors"
              (typeaheadOnSelect)="selectVendor($event, tracked_item)"
              [typeaheadOptionsLimit]="9999"
              [disabled]="tracked_item.answer_status == 'closed'"
              [typeaheadMinLength]="0"
              [typeaheadItemTemplate]="customItemTemplate"
              typeaheadOptionField="name"
              placeholder="Choose Payee"
              class="form-control chevron"
              style="margin-bottom: 10px"
              (focus)="focus($event)"
              (blur)="blur($event)"
            />

            @if (type == "receipt_requests") {
              {{ tracked_item.selectedVendorName }}
            }
          </ng-container>
          <ng-template #receivedFromTemplate>
            {{ tracked_item.integration_data.received_from }}
            <i class="tio-info_outined" style="font-size: 18px !important"></i>
          </ng-template>
        </td>

        <!-- DATE column -->
        <td
          class="no-border"
          (click)="selectTrackedItem(tracked_item)"
          style="white-space: nowrap; cursor: pointer"
        >
          {{ tracked_item.integration_data.payment_date | amDateFormat: "ll" }}
        </td>

        <!-- AMOUNT column -->
        <td
          (click)="selectTrackedItem(tracked_item)"
          class="no-border"
          style="
            text-align: right;
            font-variant-numeric: tabular-nums;
            cursor: pointer;
          "
        >
          <span
            *ngIf="
              tracked_item.integration_data.amount.toString().includes('.')
            "
          >
            ${{ tracked_item.integration_data.amount }}
          </span>
          <span
            *ngIf="
              !tracked_item.integration_data.amount.toString().includes('.')
            "
          >
            ${{ tracked_item.integration_data.amount }}.00
          </span>
        </td>

        <!-- COMMENTS column -->
        <td
          class="no-border text-center"
          (click)="selectTrackedItem(tracked_item)"
          style="cursor: pointer"
        >
          <div
            class="client-task-pill"
            tooltip="{{ tracked_item.comments.length }} comments"
          >
            <svg
              *ngIf="tracked_item.comments.length == 0"
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.75 11.75C15.75 12.1478 15.592 12.5294 15.3107 12.8107C15.0294 13.092 14.6478 13.25 14.25 13.25H5.25L2.25 16.25V4.25C2.25 3.85218 2.40804 3.47064 2.68934 3.18934C2.97064 2.90804 3.35218 2.75 3.75 2.75H14.25C14.6478 2.75 15.0294 2.90804 15.3107 3.18934C15.592 3.47064 15.75 3.85218 15.75 4.25V11.75Z"
                stroke="#485364"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              *ngIf="tracked_item.comments.length > 0"
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.75 11.75C15.75 12.1478 15.592 12.5294 15.3107 12.8107C15.0294 13.092 14.6478 13.25 14.25 13.25H5.25L2.25 16.25V4.25C2.25 3.85218 2.40804 3.47064 2.68934 3.18934C2.97064 2.90804 3.35218 2.75 3.75 2.75H14.25C14.6478 2.75 15.0294 2.90804 15.3107 3.18934C15.592 3.47064 15.75 3.85218 15.75 4.25V11.75Z"
                fill="#0075FF"
                stroke="#0075FF"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span class="comments-counter">{{
              tracked_item.comments.length
            }}</span>
          </div>
        </td>

        <!-- Deposit explanation -->
        <td
          class="no-border"
          *ngIf="tracked_item.integration_data.deposit_id != null"
        >
          <textarea
            type="text"
            class="form-control chat-input"
            placeholder="Add explanation here"
            [(ngModel)]="tracked_item.integration_data.deposit_comment"
            [readOnly]="tracked_item.answered"
          ></textarea>
        </td>

        <!-- SALES TAX -->
        <td
          class="no-border"
          *ngIf="type == 'expense' && hasSelectableSalesTax"
        >
          <input
            tooltip="{{ tracked_item.integration_data['selectedSaleTax'] }}"
            *ngIf="tracked_item.type == 6 && hasSelectableSalesTax"
            [(ngModel)]="tracked_item.integration_data['selectedSaleTax']"
            [typeahead]="salesTaxes"
            [typeaheadOptionsLimit]="9999"
            [typeaheadMinLength]="0"
            typeaheadOptionField="display"
            [disabled]="tracked_item.answer_status == 'closed'"
            (typeaheadOnSelect)="selectSalesTax($event, tracked_item)"
            placeholder="Choose Sales Tax"
            class="form-control chevron"
            style="margin-bottom: 10px"
            (focus)="focus($event)"
            (blur)="blur($event)"
          />
          <ng-template #customItemTemplate let-model="item" let-index="index">
            <div class="qb-accounts-item">
              <div class="name" title="{{ model.path }}">{{ model.path }}</div>
              <div class="category">{{ model.accountType }}</div>
            </div>
          </ng-template>
        </td>

        <!-- RECEIPT -->
        <td class="no-border" *ngIf="type === 'expense'">
          <!-- Full preview when receipt has etag -->
          <ng-container
            *ngIf="
              tracked_item.integration_data?.receipt?.etag &&
              tracked_item.answer_status === 'answered'
            "
          >
            <div
              class="file-item"
              filePreview
              [isQboItemPreview]="true"
              [type]="tracked_item.integration_data.receipt.ext"
              [etag]="tracked_item.integration_data.receipt.etag"
              [file]="tracked_item.integration_data.receipt"
            >
              <i
                class="file-icon file-{{
                  tracked_item.integration_data.receipt.ext
                }}"
                [style.background]="
                  'url(' + tracked_item.integration_data.receipt.url + ')'
                "
              ></i>
              <div class="file-name">
                {{ tracked_item.integration_data.receipt.filename }}
              </div>
            </div>
          </ng-container>

          <!-- Button to open receipt modal when no preview available -->
          <button
            [disabled]="tracked_item.answer_status == 'closed'"
            *ngIf="
              !tracked_item.integration_data?.receipt?.etag ||
              (tracked_item.integration_data.receipt &&
                tracked_item.answer_status === 'open')
            "
            class="btn btn-link position-relative receipt p-0 fw-normal btn-receipt"
            [title]="
              tracked_item.integration_data?.receipt?.filename || 'Add Receipt'
            "
            (click)="
              tracked_item.integration_data?.receipt
                ? null
                : openReceiptModal(tracked_item)
            "
          >
            <span>
              <i class="feather paperclip"></i>
              {{
                tracked_item.integration_data?.receipt?.filename ||
                  "Add Receipt"
              }}
            </span>
            <div
              class="badge"
              *ngIf="tracked_item.integration_data?.receipt"
            ></div>
          </button>

          <button
            class="btn-remove-receipt"
            tooltip="Remove receipt"
            *ngIf="
              tracked_item.integration_data?.receipt &&
              tracked_item.answer_status === 'open'
            "
            (click)="removeReceipt(tracked_item)"
          >
            <i class="feather trash-2 color-red"></i>
          </button>
        </td>

        <!-- FILE UPLOAD for receipt_requests -->
        <td class="no-border" *ngIf="type === 'receipt_requests'">
          <!-- Multiple files preview when files exist -->
          <!-- Full preview when receipt has etag -->
          <ng-container
            *ngIf="
              tracked_item.integration_data?.receipt?.etag &&
              tracked_item.answer_status === 'answered'
            "
          >
            <div
              class="file-item"
              filePreview
              [isQboItemPreview]="true"
              [type]="tracked_item.integration_data.receipt.ext"
              [etag]="tracked_item.integration_data.receipt.etag"
              [file]="tracked_item.integration_data.receipt"
            >
              <i
                class="file-icon file-{{
                  tracked_item.integration_data.receipt.ext
                }}"
                [style.background]="
                  'url(' + tracked_item.integration_data.receipt.url + ')'
                "
              ></i>
              <div class="file-name">
                {{ tracked_item.integration_data.receipt.filename }}
              </div>
            </div>
          </ng-container>

          <!-- Button to open receipt modal when no preview available -->
          <button
            [disabled]="tracked_item.answer_status == 'closed'"
            *ngIf="
              !tracked_item.integration_data?.receipt?.etag ||
              (tracked_item.integration_data.receipt &&
                tracked_item.answer_status === 'open')
            "
            class="btn btn-link position-relative receipt p-0 fw-normal btn-receipt"
            [title]="
              tracked_item.integration_data?.receipt?.filename || 'Add Receipt'
            "
            (click)="
              tracked_item.integration_data?.receipt
                ? null
                : openReceiptModal(tracked_item)
            "
          >
            <span>
              <i class="feather paperclip"></i>
              {{
                tracked_item.integration_data?.receipt?.filename ||
                  "Add Receipt"
              }}
            </span>
            <div
              class="badge"
              *ngIf="tracked_item.integration_data?.receipt"
            ></div>
          </button>

          <button
            class="btn-remove-receipt"
            tooltip="Remove receipt"
            *ngIf="
              tracked_item.integration_data?.receipt &&
              tracked_item.answer_status === 'open'
            "
            (click)="removeReceipt(tracked_item)"
          >
            <i class="feather trash-2 color-red"></i>
          </button>
        </td>

        <!-- CLASS COLUMN -->
        <td class="no-border" *ngIf="type == 'expense'" [colSpan]="2">
          <input
            tooltip="{{ tracked_item.integration_data['selectedClass'] }}"
            *ngIf="tracked_item.type == 6 && hasSelectableClass"
            [(ngModel)]="tracked_item.integration_data['selectedClass']"
            [typeahead]="classes"
            [typeaheadOptionsLimit]="9999"
            [typeaheadMinLength]="0"
            [typeaheadItemTemplate]="classSelectorTemplate"
            typeaheadOptionField="name"
            (typeaheadOnSelect)="selectClass($event, tracked_item)"
            placeholder="Choose Class"
            class="form-control chevron"
            style="margin-bottom: 10px"
            (focus)="focus($event)"
            (blur)="blur($event)"
          />
          <ng-template
            #classSelectorTemplate
            let-model="item"
            let-index="index"
          >
            <div class="qb-accounts-item">
              <div class="name" title="{{ model.name }}">{{ model.name }}</div>
            </div>
          </ng-template>
          <span *ngIf="!hasSelectableClass">—</span>
        </td>

        <!-- ACTIONS column -->
        <td
          *ngIf="type != 'expense'"
          class="no-border"
          style="white-space: nowrap"
        >
          <button
            class="btn btn-primary"
            *ngIf="tracked_item.answered == false"
            (click)="submitAnswer(tracked_item)"
            [disabled]="
              (type == 'expense' &&
                !tracked_item.integration_data.memo &&
                !tracked_item.selectedAcc) ||
              (type == 'deposit' &&
                !tracked_item.integration_data?.deposit_comment)
            "
          >
            Submit
          </button>
          <button
            class="btn btn-default justify-content-center"
            style="margin-right: 8px"
            *ngIf="
              tracked_item.answered &&
              (tracked_item.satisfied === false ||
                tracked_item.satisfied == null) &&
              data.user_type == 1 &&
              type == 'expense'
            "
            (click)="answerTrackedItem(tracked_item, false)"
          >
            Re-open
          </button>
          <button
            class="btn btn-success justify-content-center"
            *ngIf="
              tracked_item.answered &&
              (tracked_item.satisfied === false ||
                tracked_item.satisfied == null) &&
              data.user_type == 1 &&
              type == 'deposit'
            "
            style="margin-right: 8px"
            (click)="goToQuickBooks(tracked_item)"
          >
            Go to QuickBooks
          </button>
          <button
            class="btn btn-default"
            [ngClass]="{
              'btn-primary': type == 'expense' || type == 'receipt_requests',
              'btn-default': type == 'deposit',
            }"
            *ngIf="
              tracked_item.answered &&
              (tracked_item.satisfied === false ||
                tracked_item.satisfied == null) &&
              data.user_type == 1
            "
            (click)="answerTrackedItem(tracked_item, true)"
          >
            Close
          </button>
          <a
            *ngIf="type == 'expense'"
            class="btn btn-default btn-open-quickbooks"
            style="mix-blend-mode: multiply"
            rel="noreferrer noopener"
            (click)="
              navigateToQBO(
                tracked_item?.integration_data.purchase_id,
                tracked_item?.integration_data.payment_account
              )
            "
            tooltip="View in QuickBooks"
          >
            <i class="tio-open_in_new"></i>
          </a>
        </td>
      </tr>
      <tr
        *ngIf="type == 'expense'"
        style="height: 0; margin-top: -10px"
        [ngClass]="{ selected: tracked_item.selected, striped: i % 2 == 0 }"
      >
        <td
          class="no-border"
          style="padding-top: 0 !important; line-height: 1"
        ></td>
        <td
          class="no-border text-center"
          style="padding-top: 0 !important; cursor: pointer"
          (click)="selectTrackedItem(tracked_item)"
        >
          <div
            class="text-center m-auto"
            style="
              white-space: normal !important;
              line-height: 1.1;
              width: 120px;
              font-weight: bold;
            "
          >
            {{
              tracked_item.answer_status === "open"
                ? "Select account or describe transaction"
                : "—"
            }}
          </div>
        </td>
        <td
          class="qbo-cap-dropdown no-border"
          style="padding-top: 0 !important"
          *ngIf="tracked_item.integration_data.purchase_id != null"
        >
          <input
            tooltip="{{ tracked_item.selectedAcc }}"
            *ngIf="tracked_item.type == 6"
            [(ngModel)]="tracked_item.selectedAcc"
            [disabled]="tracked_item.answer_status == 'closed'"
            [typeahead]="accounts"
            (typeaheadOnSelect)="selectAccount($event, tracked_item)"
            [typeaheadOptionsLimit]="9999"
            [typeaheadMinLength]="0"
            [typeaheadItemTemplate]="customItemTemplate"
            typeaheadOptionField="name"
            placeholder="Choose Account"
            class="form-control chevron"
            style="margin-bottom: 10px"
            (focus)="focus($event)"
            (blur)="blur($event)"
          />
          <ng-template #customItemTemplate let-model="item" let-index="index">
            <div class="qb-accounts-item">
              <div class="name" title="{{ model.path }}">{{ model.path }}</div>
              <div class="category">{{ model.accountType }}</div>
            </div>
          </ng-template>
        </td>
        <td
          class="no-border"
          [colSpan]="hasSelectableSalesTax ? 5 : 4"
          style="padding-top: 0 !important"
        >
          <div class="d-flex align-items-center gap-2">
            @if (
              tracked_item.integration_data.private_note &&
              tracked_item.answer_status != "closed"
            ) {
              <i
                class="tio-info_outined"
                style="font-size: 18px !important"
                [tooltip]="
                  tracked_item.answer_status == 'closed'
                    ? tracked_item.integration_data.memo ||
                      tracked_item.integration_data.private_note
                    : tracked_item.integration_data.private_note
                "
              ></i>
            }
            <textarea
              class="form-control"
              placeholder="Describe transaction"
              [(ngModel)]="tracked_item.integration_data.memo"
              style="height: 38px"
              [disabled]="tracked_item.answer_status == 'closed'"
            ></textarea>
          </div>
        </td>
        <td
          class="no-border"
          style="white-space: nowrap; padding-top: 0 !important"
        >
          <button
            class="btn btn-primary"
            *ngIf="tracked_item.answered == false"
            (click)="submitAnswer(tracked_item)"
            [disabled]="
              (!tracked_item.integration_data.memo &&
                !tracked_item.selectedAcc) ||
              (type == 'deposit' &&
                !tracked_item.integration_data.deposit_comment) ||
              tracked_item.integration_data.deposit_comment == ''
            "
          >
            Submit
          </button>
          <button
            class="btn btn-default justify-content-center"
            style="margin-right: 8px"
            *ngIf="
              tracked_item.answered &&
              (tracked_item.satisfied === false ||
                tracked_item.satisfied == null) &&
              data.user_type == 1 &&
              type == 'expense'
            "
            (click)="answerTrackedItem(tracked_item, false)"
          >
            Re-open
          </button>
          <button
            class="btn btn-success justify-content-center"
            *ngIf="
              tracked_item.answered &&
              (tracked_item.satisfied === false ||
                tracked_item.satisfied == null) &&
              data.user_type == 1 &&
              type == 'deposit'
            "
            style="margin-right: 8px"
            (click)="goToQuickBooks(tracked_item)"
          >
            Go to QuickBooks
          </button>
          <button
            class="btn btn-default"
            [ngClass]="{
              'btn-primary': type == 'expense' || type == 'receipt_requests',
              'btn-default': type == 'deposit',
            }"
            [disabled]="!tracked_item.selectedAcc"
            *ngIf="
              tracked_item.answered &&
              (tracked_item.satisfied === false ||
                tracked_item.satisfied == null) &&
              data.user_type == 1
            "
            (click)="answerTrackedItem(tracked_item, true)"
          >
            Close
          </button>
          <a
            *ngIf="type == 'expense'"
            class="btn btn-default btn-open-quickbooks d-inline-flex align-items-center justify-content-center"
            style="padding: 0; mix-blend-mode: multiply"
            rel="noreferrer noopener"
            (click)="
              navigateToQBO(
                tracked_item?.integration_data.purchase_id,
                tracked_item?.integration_data.payment_account
              )
            "
            tooltip="View in QuickBooks"
          >
            <i class="tio-open_in_new"></i>
          </a>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
